/* oxlint-disable react/forbid-elements -- Original product pictograms from the approved export. */
import * as React from 'react';
import { cx } from './styles';
import { ICareerProduct } from '../../content/career/products';

const ProductsContext = React.createContext<{
  active: string | null;
  setActive: (id: string | null) => void;
}>({ active: null, setActive: () => undefined });

export const CareerProducts: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [active, setActive] = React.useState<string | null>(null);
  const value = React.useMemo(() => ({ active, setActive }), [active]);

  return <ProductsContext.Provider value={value}>{children}</ProductsContext.Provider>;
};

export const CareerProduct: React.FC<{ product: ICareerProduct }> = ({ product }) => {
  const { id, title, description, paths } = product;
  const { active, setActive } = React.useContext(ProductsContext);
  const open = active === id;

  return (
    <article className={cx(`main_system_card ${id === 'product-7' ? 'layout10' : ''}`)} data-open={open}>
      <button
        type="button"
        id={`${id}-trigger`}
        className={cx('product-trigger')}
        aria-label={title}
        aria-expanded={open}
        aria-controls={`${id}-content`}
        onClick={() => setActive(open ? null : id)}
      >
        <span className={cx('main_system_card-heading')}>
          <svg
            viewBox="0 0 56 56"
            fill="none"
            className={cx('icon-1x1-large text-color-brand-orange')}
            aria-hidden="true"
          >
            {paths.map((path, index) => (
              <path key={index} {...path} />
            ))}
          </svg>
          <span className={cx('main_system_card-bottom')}>
            <span role="heading" aria-level={4} className={cx('heading-style-h3 multiline')}>
              {title}
            </span>
            <span className={cx('icon-wrapper is-accordion-main product-plus')} aria-hidden="true">
              <svg viewBox="0 0 20 20" fill="none" className={cx('icon-1x1-small text-color-brand-blue')}>
                <path d="M10 0V20M0 10H20" stroke="currentColor" strokeWidth="2.5" />
              </svg>
            </span>
          </span>
        </span>
      </button>
      <div id={`${id}-content`} role="region" aria-labelledby={`${id}-trigger`} hidden={!open}>
        <div className={cx('spacer-accordion')} />
        <p>{description}</p>
      </div>
    </article>
  );
};
